import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useState } from 'react';

import { FormattedMessage } from '@flipster/i18n';
import { Checkbox } from '@flipster/react/design-system/checkbox';
import { Modal } from '@flipster/react/design-system/modal';
import { stack } from '@flipster/styled-system/patterns';
import { PusdtCurrency } from '@flipster/utils/constants/currency';

import { CurrencyDisplay } from '../../../misc/display';
import { CheckboxAgreementText, PremiumEarnTerms } from '../premium-earn-terms';
import { pusdtAgreementBunja } from '../state';

interface Props {
  goToInfo: () => void;
  onClose: () => void;
}

const TermsStep = ({ goToInfo, onClose }: Props) => {
  const { pusdtTermAgreedAtom, postV2Agreement } = useBunja(pusdtAgreementBunja);
  const pusdtTermAgreed = useAtomValue(pusdtTermAgreedAtom);

  const [checkAgree, setCheckAgree] = useState(false);

  return (
    <>
      <Modal.Header>
        <div className={stack({ gap: 8 })}>
          <CurrencyDisplay
            currency={PusdtCurrency}
            icon={<CurrencyDisplay.Icon size={24} space={8} />}
            mainLabel={<CurrencyDisplay.Label value='fullName' />}
          />
          <Modal.Title label={<FormattedMessage id='Common.r260202.Terms_and_conditions' />} />
        </div>
      </Modal.Header>
      <Modal.Content>
        <PremiumEarnTerms />
      </Modal.Content>
      <Modal.Footer align='vertical'>
        <Modal.Button
          size='large'
          label={
            pusdtTermAgreed ? (
              <FormattedMessage id='Common.r250401.Back' />
            ) : (
              <FormattedMessage id='Common.r250401.Continue' />
            )
          }
          disabled={!(checkAgree || pusdtTermAgreed)}
          onClick={async () => {
            if (pusdtTermAgreed) {
              goToInfo();
              return;
            }
            await postV2Agreement();
            onClose();
          }}
        />
        {!pusdtTermAgreed && (
          <Checkbox checked={checkAgree} onChange={(e) => setCheckAgree(e.target.checked)} css={{ mb: 24 }}>
            <CheckboxAgreementText />
          </Checkbox>
        )}
      </Modal.Footer>
    </>
  );
};

export default TermsStep;
